<template>
    <div>
        <portal to="buttons">

        </portal>

        <b-card no-body>
            <data-table ref="dataTable" url="/api/stock" sort="Name" :desc="false" :per-page="10" :columns="columns" :filter.sync="filter" cache-search="tableStock">

                <template #create>
                    <b-button variant="success" class="mr-10" @click="scanModal(true)">
                        Lager ind
                    </b-button>
                    
                    <b-button variant="danger" @click="scanModal(false)">
                        Lager ud
                    </b-button>
                </template>

                <template #Name="data">
                    <b-link :to="'/products/' + data.item.Id">{{data.value}}</b-link>
                </template>

                
                <template #TrackStock="data">
                    <feather-icon v-if="data.value" icon="CheckCircleIcon" size="18" />
                    <feather-icon v-else icon="CircleIcon" size="18" />
                </template>


                <template #CreateDate="data">
                    <span class="text-nowrap">
                        {{ $moment(data.value).format("DD. MMM YYYY") }}
                    </span>
                </template>

                <template #actions="data">
                    <div class="text-nowrap">
                        <b-button @click="editItem(data.item)" variant="link" class="p-0">
                            <feather-icon icon="EditIcon" size="16" class="mx-6 my-2" />
                        </b-button>
                    </div>
                </template>

            </data-table>
        </b-card>

        <ScanModal :scanIn="scanIn"></ScanModal>
    </div>
</template>

<script>
    import DataTable from "@/components/DataTable.vue"
    import ScanModal from './_scanModal.vue'

    export default {
        components: {
            DataTable, ScanModal
        },
        data: () => ({
            filter: {},
            editId: null,
            columns: [
                //{ key: 'id', label: '#', sortable: true },
                { key: 'Name', label: 'Navn', sortable: true, stickyColumn: false },
                { key: 'SKU', label: 'Varenummer', sortable: true },
                { key: 'GTIN', label: 'EAN', sortable: true },
                { key: 'Stock', label: 'Lager', sortable: true },
                { key: 'TrackStock', label: 'Lagerstyring', sortable: false },
                { key: 'CreateDate', label: 'Oprettet', sortable: true },
                { key: 'actions', label: '', class: "text-right" },
            ],
            scanIn: true
        }),
        computed: {},
        created() { },
        mounted() { },
        methods: {
            scanModal(scanIn) {
                this.scanIn = scanIn
                this.$bvModal.show('scanModal')
            }
        },
    }
</script>